const statusOptions = [
  { text: 'Active', value: 1 },
  { text: 'Pending', value: 0 },
  { text: 'Not Hired', value: 2 },
  { text: 'Inactive', value: 3 },
  { text: 'Benched', value: 4 }
];

export default statusOptions;
